<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="8" class="text-justify">
          <h2 class="display-2 text-center mb-4 text-secondary">Star Wars Wikidata Datasets</h2>
  
          <p class="text-body-1">
            Welcome to The Ultimate Star Wars Planet Datasets page! Here, you can access datasets extracted from Wikidata related to the Star Wars franchise. These datasets include entities, their properties, and associated labels and descriptions, serialized in multiple formats.
            You can download the datasets from our GitHub repository:
          </p>
          <v-col cols="12" md="12" class="text-center">
            <v-btn color="secondary" large href="https://github.com/yoanchabot/holonet_datasets" target="_blank">Access on GitHub</v-btn>
          </v-col>
          <v-col cols="12" md="12" class="text-center">
            <v-btn color="secondary" large href="https://huggingface.co/datasets/holonetgalactic/ultimatestarwarsplanets" target="_blank">Access on Hugging Face</v-btn>
          </v-col>
          <v-col cols="12" md="12" class="text-center">
            <v-btn color="secondary" large href="https://www.kaggle.com/datasets/holonetencyclopedia/the-ultimate-star-wars-planet-dataset" target="_blank">Access on Kaggle</v-btn>
          </v-col>
        
          <h3 class="text-secondary">Usage</h3>
          <p class="text-body-1">
            These datasets can be used for various applications, such as:
          </p>
          <ul class="text-body-1 pl-6">
            <li>Training AI models to generate new planets or predict features within the Star Wars universe.</li>
            <li>Building knowledge graphs for educational purposes or practice.</li>
            <li>Analyzing the relationships between different entities in the Star Wars universe.</li>
            <li>Integrating Star Wars data into applications that require structured data.</li>
          </ul>
  
          <h3 class="mt-5 text-secondary">License</h3>
          <p class="text-body-1">
            The datasets are licensed under the <a href="https://github.com/yoanchabot/holonet_datasets?tab=CC0-1.0-1-ov-file#readme" target="_blank">CC0 1.0 Universal License</a>. Please attribute Wikidata as the source of the data and include a link to the license.
          </p>

          <!-- Cite this work -->
            <h3 class="mt-5 text-secondary">4. Cite this work</h3>
            <p class="text-body-1">
            Yoan Chabot (2025). Holonet Galactic Encyclopedia. Retrieved from https://sw-holonet.com/
            </p>
        </v-col>
      </v-row>
    </v-container>
  </template>

<script>
import { useHead } from '@unhead/vue';

export default {
  name: 'About',
  setup() {
    useHead({
      title: "Star Wars Datasets – Wikidata Extracts for AI & Knowledge Graphs",
      meta: [
        {
          name: "description",
          content: "Download structured Star Wars datasets extracted from Wikidata. Ideal for AI training, knowledge graphs, research, and creative projects. Available in CSV, JSON, N-Triples, and Turtle formats.",
        },
        {
          property: "og:title",
          content: "Star Wars Datasets – Wikidata Extracts for AI & Knowledge Graphs",
        },
        {
          property: "og:description",
          content: "Explore and download Star Wars datasets from Wikidata in multiple formats (CSV, JSON, N-Triples, Turtle). Perfect for AI, research, and knowledge graph applications.",
        },
        {
          property: "og:url",
          content: "https://sw-holonet.com/datasets",
        },
        { property: "og:type", content: "website" },
        {
          name: "twitter:title",
          content: "Star Wars Datasets – Wikidata Extracts for AI & Knowledge Graphs",
        },
        {
          name: "twitter:description",
          content: "Access comprehensive Star Wars datasets from Wikidata. Use for AI training, knowledge graphs, and research. Available in CSV, JSON, and RDF formats.",
        },
        { name: "twitter:card", content: "summary" },
        {
          name: "keywords",
          content: "Star Wars datasets, Wikidata Star Wars, Star Wars data, AI training datasets, knowledge graphs, Star Wars research, CSV datasets, JSON datasets, N-Triples, Turtle format, RDF datasets",
        },
      ],
    });
    }
};
</script>
  
